import React from 'react';
import styled from 'styled-components';
const StyledInput = styled.input `
    transition: all 300ms ease-in-out;
    padding: ${props => props.bordered ? '10px 15px 15px 15px' : '10px 0px 15px 0px'};
    background-color: white;
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    width: 100%;
    margin-top: auto;
    outline: none;
    font-size: 16px;
    font-weight: 400;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:focus {
        border-bottom-color: transparent;

        ~ .focus-border {
            transform: scaleX(1);
        }
    }

    &:disabled:focus {
        background-color: ${({ theme }) => theme.border};

        ~ .focus-border {
            opacity: 0;
        }
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }

    &[type='date']::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
    }

    &[type='date'] {
        padding: 10px 0 13px 0;
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &[type='date']:focus,
    &[type='date']:valid:not(:empty) {
        font-weight: 600;
        color: ${props => props.theme.primary};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    &::placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
        opacity: 1;
    }

    &:-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &::-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &::-webkit-datetime-edit-year-field:not([aria-valuenow]) {
        color: rgba(41, 48, 87, 0.25);
    }

    &::-webkit-datetime-edit-month-field:not([aria-valuenow]) {
        color: rgba(41, 48, 87, 0.25);
    }

    &::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
        color: rgba(41, 48, 87, 0.25);
    }

    &:not([value='']):not(:focus) {
        font-weight: 400;
    }

    &:not([value='']):not(:focus):invalid {
        color: #d70e24;
    }

    &[value='0000-00-00']::-webkit-datetime-edit {
        color: transparent;
    }
`;
const Input = props => React.createElement(StyledInput, Object.assign({}, props));
export default Input;
